import { Component, ContentChild, DoCheck, EventEmitter, Input, IterableDiffers, OnInit, Output, TemplateRef } from '@angular/core';
import { cloneDeep, groupBy } from 'lodash';
import { DndDropEvent } from 'ngx-drag-drop';
import { NGXLogger } from 'ngx-logger';
import { Filtrable, Page } from 'orv-ui-base-lib';

@Component({
	selector: 'app-draggable-cards',
	templateUrl: './draggable-cards.component.html',
	styleUrls: ['./draggable-cards.component.scss']
})
export class DraggableCardsComponent implements OnInit, DoCheck {

	// all cards map
	itemsMap: any = {};

	@Input()
	disablednd: boolean = false;

	@Input() scrollable: boolean = false;

	@Input() minindex: number;

	@Input() forcesort = false;

	filteredItems: Filtrable[] = [];
	pageAvailable: Page = new Page();
	pageSelected: Page = new Page();
	@ContentChild(TemplateRef) parentTemplate;

	keyword: string;

	@Input()
	filterable: boolean = false;
	_iterableDiffers: any;

	@Input()
	items: Filtrable[];

	@Input()
	cardid: string;


	@Output() onRemove = new EventEmitter<any>();
	@Output() onEdit = new EventEmitter<Filtrable>();
	@Output() onDragEnd = new EventEmitter<Filtrable>();
	@Output() onDragStart = new EventEmitter<Filtrable>();
	@Output() onDragCanceled = new EventEmitter<Filtrable>();
	@Output() onOrderChanged = new EventEmitter<any>();

	sortfield: string;

	constructor(private logger: NGXLogger, private iterableDiffers: IterableDiffers) {
		this._iterableDiffers = this.iterableDiffers.find([]).create(null);
	}

	ngDoCheck() {
		const changes = this._iterableDiffers.diff(this.items);
		if (changes) {
			this.itemsMap = groupBy(this.items, this.cardid);
		}
	}

	ngOnInit() {
	}

	onDragover(event: DragEvent) {
	}

	onDrop(event: DndDropEvent) {
		console.log(this.items);
		if (event.data && this.itemsMap[event.data] && event.index !== undefined && (this.minindex === undefined || event.index > this.minindex)) {
			this.addItem(this.itemsMap[event.data][0], event.index);
		}
	}

	addItem(item: Filtrable, index: number) {
		if (!this.items) {
			this.items = [];
		}

		let itemtoadd: Filtrable;
		let remindex: number;

		if (this.itemsMap[item[this.cardid]]) {// c'è già, va spostata
			itemtoadd = this.itemsMap[item[this.cardid]][0];
			remindex = this.items.indexOf(itemtoadd);
			if (remindex >= index) {
				remindex++;
			}

		}
		this.items.splice(index, 0, itemtoadd);

		if (remindex >= 0) {

			this.removeItem(remindex, false);
		}

		this.onOrderChanged.emit();
	}


	removeItem(index: number, emit?: boolean) {
		this.logger.log('remove item', index);


		if (emit) {
			const removed = cloneDeep(this.items[index]);
			this.onRemove.emit({ data: removed, index: index });
		} else {
			this.items.splice(index, 1);
		}
	}

	editItem(item: Filtrable) {
		this.onEdit.emit(item);
	}

	dragEnd(item: Filtrable) {
		if (this.onDragEnd)
			this.onDragEnd.emit(item);
	}

	dragStart(item: Filtrable) {
		if (this.onDragStart)
			this.onDragStart.emit(item);
	}

	dragCanceled(item: Filtrable) {
		if (this.onDragCanceled)
			this.onDragCanceled.emit(item);
	}


	sortItems(sortfield: string) {
		this.sortfield = sortfield;
		this.items = this.items.sort((a, b) => a[sortfield] - b[sortfield]);
	}




}
